import axiosInstance from './axios-config'

export const getAssetKeyFacts = async (keys) => {
  const assetId=keys?.queryKey[1]
  if(assetId) {
    const {data} = await axiosInstance.get(`/api/v1/Assets/${assetId}/KeyFacts`) // /api/v1/Assets/{assetId}/Actions
    return data
  }
}